import React from 'react'
import { Component } from 'react'
import { ReactSVG } from 'react-svg'
import {Footer} from '../../Footer'
import './index.css'

import {getMe} from '../../../Me'
import { isDesktop, isIPad, isMobile } from '../../../Platform'

const me = getMe()

export class Home extends Component { 
    constructor (props) {
        super(props)
    }
    
    navButtonClicked = (location) => {
        this.props.navClick(location);
    }


    renderProjectGraphic = () => {
        return (
            <div className='nanoHOMEGraphicParent'>
                <div className='nanoHOMEGraphic0Container'>
                    <img src={!isMobile() ? this.props.nano.images[0].media : this.props.nano.images[1].media} />
                </div>
            </div>
        )
    }

    renderProjectButtons = (lnk) => {
        if(isMobile()) {
            if(lnk.internal) {
                return(    
                    <a className={'nano'+lnk.link+'FooterHREF'} onClick={()=>this.navButtonClicked(lnk.link)} target='_blank'>
                        <div className='nanoHOMEFooterLinkInternal'>
                            <ReactSVG src={lnk.title} />
                        </div>
                        <div className='nanoHOMEFooterIconInternal'>
                            <ReactSVG src={lnk.icon} />
                        </div>
                    </a>
                );
            } else {
                return(
                    <a className={'nano'+lnk.link+'FooterHREF'} href={lnk.hlink} target='_blank'>
                        <div className='nanoHOMEFooterLink'>
                            <div className='nanoHOMEFooterLinkTitle'>{lnk.title}</div>
                            <div className='nanoHOMEFooterLinkSInfo'>{lnk.info}</div>
                        </div>
                        <div className='nanoHOMEFooterIcon'>
                            <ReactSVG src={lnk.icon} />
                        </div>
                    </a>
                );
            }
        } else {
            if(!lnk.internal) {
                return(
                    <a className={'nano'+lnk.link+'FooterHREF'} href={lnk.hlink} target='_blank'>
                        <div className='nanoHOMEFooterLink'>
                            <div className='nanoHOMEFooterLinkTitle'>{lnk.title}</div>
                            <div className='nanoHOMEFooterLinkSInfo'>{lnk.info}</div>
                        </div>
                        <div className='nanoHOMEFooterIcon'>
                            <ReactSVG src={lnk.icon} />
                        </div>
                    </a>
                );
            }
        }
    }

    render() {
        // fix for react muted
        var videoHTML = "<video class='bgVideo' loop muted autoplay playsinline src="+me.getDefaultVideo()+" type='video/mp4' />";

        return(
        
            <div className='nanoHOMEBackground'>
                <div className='nanoBackgroundVideo' dangerouslySetInnerHTML={{ __html: videoHTML}}></div>
                <div key={this.props.nano.name} className={this.props.fade} >
                <div className={'nano'+this.props.nano.name+'BackgroundGradient'}></div>
                <div className='nanoHOMEHeaderContent'>
                    <div className='nanoHOMEHeader'></div>
                    <div className={(this.props.fade === 'nanoFadeIn') ? 'nanoHOMEProjectAnim' : ''}>
                        <div className={'nano'+this.props.nano.name+'Project'}>
                            <div className='nanoHOMEDetails'>
                                <div className='nanoHOMEDetailsHeader'>
                                    <div className='nanoHOMEDetailsTitle'><ReactSVG src={this.props.nano.logo} /></div>
                                    <div className='nanoHOMEDetailsTag'>{this.props.nano.headline}
                                    </div>
                                </div>
                                
                                {(isMobile() && !isIPad()) ? this.renderProjectGraphic() : ''}

                                <div className='nanoHOMEDetailsFeatures'>
                                    {this.props.nano.features.map((lnk, i) => {
                                        return (
                                            <div key={i} className='nanoHOMEDetailsFeature'>
                                                <div className='nanoHOMEDetailsFeatureIcon'><ReactSVG src={lnk.media} /></div>
                                                <div className='nanoHOMEDetailsFeatureText'>{lnk.name}</div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            
                            {!isMobile() ? this.renderProjectGraphic() : ''}
                            
                        </div>
                    </div>
                    <div className='nanoHOMEFooter'>
                        {this.props.nano.buttons.map((lnk, i) => {
                            var renderbutton = false;

                            if(lnk.internal && isMobile()) {
                                renderbutton = true;
                            } else {
                                if(!lnk.internal) {
                                    renderbutton = true;
                                }
                            }

                            if(renderbutton) {
                                return (
                                    <div key={i} className='nanoHOMEFooterButtons'> 
                                        {this.renderProjectButtons(lnk)}
                                    </div>
                                );
                            }
                         })}
                        <div className='nanoHOMEFooterSpace'></div>
                    </div>
                    {isMobile() ? <Footer /> : ''}
                </div>
            </div>
            {!isMobile() ? <Footer /> : ''}
        </div>
    )}

    componentDidMount() {
        // dom node created
    }

    componentWillUnmount () {
        // dom node deleted
    }

    componentDidUpdate(previousProps, previousState) {
        
    }
}
